import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IPen = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg width={props.width??"32"} height={props.height??"32"} viewBox={`0 0 ${props.width} ${props.height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.58824 23.4118H9.92394L20.7626 12.5731L19.4269 11.2374L8.58824 22.0761V23.4118ZM7 25V21.4164L20.9664 7.45609C21.1265 7.31068 21.3032 7.19835 21.4966 7.11912C21.6902 7.03971 21.8931 7 22.1054 7C22.3177 7 22.5233 7.03768 22.7222 7.11303C22.9213 7.18838 23.0975 7.30821 23.2508 7.4725L24.5439 8.78174C24.7082 8.93509 24.8253 9.11156 24.8952 9.31115C24.9651 9.51074 25 9.71032 25 9.90991C25 10.1229 24.9636 10.3261 24.8909 10.5195C24.8182 10.7131 24.7026 10.8899 24.5439 11.05L10.5836 25H7ZM20.0831 11.9169L19.4269 11.2374L20.7626 12.5731L20.0831 11.9169Z"
              fill={props.color ?? "#4B5672"} />
          </svg>

        );
      }}
      {...props}
    />
  );
};

export default IPen;
